import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs } from 'react-breadcrumbs-dynamic';
import { withStyles, AppBar, Toolbar, Typography } from './../../../../themes/default';
import Link from './../../ui/link';

const styles = theme => ({
  root: {
    paddingTop: theme.spacing.unit * 2
  },
  appbar: {
    boxShadow: theme.shadows[0],
    background: 'none'
  }
});

const ToolbarPrimary = ({children, title, actions, classes, ...rest}) => {

  return (
    <div className={ classes.root }>
      <AppBar position="static" color="default" component="div" className={ classes.appbar }>
        <Toolbar className={ classes.toolbar }>
          <div className={ classes.title }>
            <Typography variant="h6" color="inherit" className={ classes.title }>
              { title }
            </Typography>
            <Typography component="div">
              <Breadcrumbs
                separator={<b> / </b>}
                item={ Link }
                finalItem={'span'}
                finalProps={{
                  style: { color: '#ccc' }
                }}
              />
            </Typography>
          </div>
          <div className={ classes.actions }>
            { actions }
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )

}

ToolbarPrimary.propTypes = {
  title: PropTypes.string.isRequired,
  actions: PropTypes.node
};


export default withStyles(styles)(ToolbarPrimary);
